import { render, staticRenderFns } from "./CartaCarencia.vue?vue&type=template&id=5690da8f&scoped=true&"
import script from "./CartaCarencia.vue?vue&type=script&lang=js&"
export * from "./CartaCarencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5690da8f",
  null
  
)

export default component.exports